var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"section-title mb-2"},[_vm._v("付加情報")]),_c('ul',{staticClass:"place-info"},[_c('li',[_c('span',[_vm._v("交通種別：")]),_c('span',[_vm._v(_vm._s(_vm.getTraffic(_vm.place.type)))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }